import React from 'react';
import {Card, Checkbox, Typography} from "@mui/material";
import {Box} from "@mui/system";
import RecommendedSettingConfigs from "./RecommendedSettingConfigs";
import Grid2 from "@mui/material/Unstable_Grid2";
import {COLORS} from "../../../ui/Theme";
import {ListDivider} from "../../../ui/ListStyles";

const persianTitles = {
    money_flow: "ورود پول حقیقی",
    buy_pressure: "قدرت خرید حقیقی",
    buy_value: "خرید درشت حقیقی",
    buy_ratio: "نسبت سفارش‌های خرید",
    sell_ratio: "نسبت سفارش‌های فروش",
    roi: "بازدهی سهام",
    value_change: "ارزش معاملات",
    call_value_change: "ارزش اختیارهای خرید",
    put_value_change: "ارزش اختیارهای فروش",
    option_price_spread: "اسپرد قیمتی",
    global: "بازار جهانی",
    domestic: "بازار داخلی",
};

const RecommendedSettingConfigCard = ({data, isChecked, onCheckboxChange, onInputChange}) => {

    return (
        <Grid2 md={6} lg={4} xl={2.4}>
            <Card>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <Checkbox
                            checked={isChecked}
                            onChange={onCheckboxChange}
                            sx={{
                                color: COLORS.GRAY,
                                padding: "0",
                                "&.Mui-checked": {
                                    color: "#1976d2",
                                },
                            }}
                        />
                        <Typography>{persianTitles[data.name]}</Typography>
                    </Box>
                    <ListDivider/>
                    <RecommendedSettingConfigs
                        data={data}
                        onInputChange={onInputChange}
                    />
                </Box>
            </Card>
        </Grid2>
    );
};

export default RecommendedSettingConfigCard;